import React, { useEffect, useState, useRef } from 'react';
import $ from 'jquery';
import 'jquery-scrollify';

import SectionBanner from './SectionBanner';
import SectionOurStory from './SectionOurStory';
import SectionOurWork from './SectionOurWork';
import SectionFacilities from './SectionFacilities';
import SectionNewsAndBlogs from './SectionNewsAndBlogs';

import './styles/Home.css';
import Footer from './Footer';
import Header from './Header';

const Home = () => {
  const [showHeader, setShowHeader] = useState(false);
  const [fadeInHeader, setFadeInHeader] = useState(false);
  const [fadeInFooter, setFadeInFooter] = useState(false);

  // ✅ NEW STATE (important)
  const [activeSection, setActiveSection] = useState('banner');
  const [showFixedHeading, setShowFixedHeading] = useState(false);

  const headerTimeout = useRef(null);
  const footerTimeout = useRef(null);

  useEffect(() => {

    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    const handleScroll = () => {
    const scrollY = window.scrollY;

    const heading = document.querySelector('.fixed-heading');
    if (heading) {
      heading.style.transform = `translateY(calc(-50% + ${scrollY * 0.1}px))`;
    }
  };

    setVh();
    window.addEventListener('resize', setVh);

    window.jQuery = $;
    window.$ = $;

    $.scrollify({
      section: '.scroll-section',
      scrollSpeed: 800,
      scrollbars: true,
      setHeights: true,
      standardScrollElements: '.scrollable',
      overflowScroll: true,

      before: (i, sections) => {

  const sectionNames = [
    'banner',
    'our story',
    'our work',
    'facilities',
    'news & blogs',
    'footer'
  ];

  setActiveSection(sectionNames[i]);

  
  const isFirst = i === 0;
  const isLast = i === sections.length - 1;

  // ✅ SHOW / HIDE FIXED HEADING
  if (isFirst || isLast) {
    setShowFixedHeading(false);
  } else {
    setShowFixedHeading(true);
  }

  $('.scroll-section').css({ zIndex: 1, position: 'relative' });

  if (headerTimeout.current) clearTimeout(headerTimeout.current);

  if (isFirst || isLast) {
    setFadeInHeader(false);
    setShowHeader(false);
  } else {
    setShowHeader(true);
    headerTimeout.current = setTimeout(() => {
      setFadeInHeader(true);
    }, 10);
  }
},

      after: (i, sections) => {
        const current = $(sections[i]);
        current.css({ zIndex: 2 });

        const isLast = i === sections.length - 1;

        if (footerTimeout.current) clearTimeout(footerTimeout.current);

        if (isLast) {
          footerTimeout.current = setTimeout(() => {
            setFadeInFooter(true);
          }, 3000);
        } else {
          setFadeInFooter(false);
        }
      },
    });

    return () => {
      if ($.scrollify && $.scrollify.destroy) {
        $.scrollify.destroy();
      }

      window.removeEventListener('resize', setVh);
      window.removeEventListener('scroll', handleScroll);

      if (headerTimeout.current) clearTimeout(headerTimeout.current);
      if (footerTimeout.current) clearTimeout(footerTimeout.current);
    };
  }, []);

  return (
    <>
      {/* ✅ FIXED GLOBAL HEADING */}
      {showFixedHeading && (
  <div className="fixed-heading">
    <h3 className="section-heading">{activeSection}</h3>
  </div>
)}

      {showHeader && (
        <Header className={`fade-header ${fadeInHeader ? 'visible' : ''}`} />
      )}

      <div className="scroll-section"><SectionBanner /></div>
      <div className="scroll-section"><SectionOurStory /></div>
      <div className="scroll-section"><SectionOurWork /></div>
      <div className="scroll-section"><SectionFacilities /></div>
      <div className="scroll-section"><SectionNewsAndBlogs /></div>

      <div className="scroll-section scrollable">
        <Footer className={`fade-footer ${fadeInFooter ? 'visible' : ''}`} />
      </div>
    </>
  );
};

export default Home;